export const removeNonDigit = str => {
  if (str) {
    return str.toString().replace(/\D+/g, '');
  }
};
